import React, { useEffect, useState } from 'react';
import { Table, Modal, Button, Form, Dropdown, Card } from 'react-bootstrap';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import moment from 'moment';
import { AccessFidele, CreateFidele, LoadAllFideles, SendEventMessageToFidele, StopFidele, UpdateFidele } from '../../../actions/Fideles/FideleAction';
import { MdSearch, MdSend } from 'react-icons/md';
import { toast } from 'react-toastify';
import { LoadAllEvent } from '../../../actions/Activites/Evenement';
import Select from "react-select";

const ListFidelesPage = () => {
  const [fidelelist, setFidelelist] = useState([]);

  const [showEventModal, setShowEventModal] = useState(false);

  const [showModal, setShowModal] = useState(false);
  const [showCreateModal, setShowCreateModal] = useState(false);

  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [filteredFideles, setFilteredFideles] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');

  const [eventList, seteventList] = useState([]);
  const [eventSelect, seteventSelect] = useState();



  const [newFidele, setNewFidele] = useState({
    firstname: '',
    lastname: '',
    email: '',
    telephone: '',
    address: '',
    codePostal: '225'
  });

  const [selectedFidele, setSelectedFidele] = useState({
    firstname: '',
    lastname: '',
    email: '',
    telephone: '',
    address: '',
    codePostal: '225'
  });

  const [selectedFideles, setSelectedFideles] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  const eventOptions = eventList.map((item) => { return ({ value: item?._id, label: item?.title, description: item?.description, image: item?.coverPicture, date: moment(item?.date).format("DD-MM-YYYY") }) }) || []


  const countryCodes = [
    { name: 'Côte d’Ivoire', code: '225' },
    { name: 'Ghana', code: '233' },
    { name: 'France', code: '33' },
    { name: 'USA', code: '1' },
    { name: 'UK', code: '44' },
    { name: 'Canada', code: '1' },
    { name: 'Germany', code: '49' },
    { name: 'Nigeria', code: '234' },
    { name: 'South Africa', code: '27' },
    { name: 'Kenya', code: '254' }
  ];


  useEffect(() => {
    LoadAllFideles(setFidelelist);
    LoadAllEvent(seteventList);
  }, []);


  //  evenet

  const handleShowEventModal = () => {
    setShowEventModal(true);
  };
  const handleCloseEventModal = () => {
    setShowEventModal(false);
  };


  // /fidels
  const handleShowModal = (fidele) => {
    setSelectedFidele(fidele);
    setShowModal(true);
  };

  const handleShowCreateModal = () => {
    setShowCreateModal(true);
  };

  const handleCloseModal = () => {
    setSelectedFidele(null);
    setShowModal(false);
  };

  const handleCloseCreateModal = () => {
    setShowCreateModal(false);
    setNewFidele({ firstname: '', lastname: '', email: '', telephone: '', address: '', codePostal: '' });
  };

  const handleFilter = () => {
    if (startDate && endDate) {
      const start = moment(startDate).startOf('day');
      const end = moment(endDate).endOf('day');
      const filtered = fidelelist.filter((fidele) => {
        const createdAt = moment(fidele.createdAt);
        return createdAt.isBetween(start, end);
      });
      setFilteredFideles(filtered);
    } else {
      setFilteredFideles(fidelelist);
    }
  };

  const exportPDF = () => {
    const doc = new jsPDF();
    doc.setProperties({
      title: 'Liste des Fidèles',
      subject: 'Gestion des Fidèles',
      author: 'Système de Gestion',
    });

    doc.text('Liste des Fidèles', 14, 10);
    doc.autoTable({
      head: [['Nom', 'Prénoms', 'Email', 'Indicatif', 'Téléphone', 'Adresse']],
      body: (filteredFideles.length > 0 ? filteredFideles : fidelelist).map((fidele) => [
        fidele?.firstname,
        fidele?.lastname,
        fidele?.email,
        fidele?.codePostal,
        fidele?.telephone,
        fidele?.address,
      ]),
    });
    doc.save('fideles.pdf');
  };



  const handleCreateFidele = () => {
    const completeFidele = { ...newFidele, telephone: phoneNumber + newFidele.telephone };
    if (!completeFidele.firstname) {
      toast.error("Nom obligatoire"); return;
    }
    if (!completeFidele.lastname) {
      toast.error("Prénoms obligatoire"); return;
    }
    if (!completeFidele.codePostal) {
      toast.error("Indicatif téléphone obligatoire"); return;
    }
    if (!completeFidele.telephone) {
      toast.error("Numéro de téléphone obligatoire"); return;
    }
    CreateFidele(completeFidele);
    LoadAllFideles(setFidelelist)
    LoadAllFideles(setFilteredFideles)
    handleCloseCreateModal();
  };

  const handleUpdateFidele = () => {
    if (!selectedFidele.firstname) {
      toast.error("Nom obligatoire"); return;
    }
    if (!selectedFidele.lastname) {
      toast.error("Prénoms obligatoire"); return;
    }
    if (!selectedFidele.codePostal) {
      toast.error("Indicatif téléphone obligatoire"); return;
    }
    if (!selectedFidele.telephone) {
      toast.error("Numéro de téléphone obligatoire"); return;
    }

    UpdateFidele(selectedFidele._id, selectedFidele);
    LoadAllFideles(setFidelelist)
    LoadAllFideles(setFilteredFideles)


    handleCloseModal();
  };



  const toggleSelectAll = () => {
    setSelectAll(!selectAll);
    if (!selectAll) {
      setSelectedFideles(filteredFideles.length > 0 ? filteredFideles : fidelelist);
    } else {
      setSelectedFideles([]);
    }
  };

  const toggleSelectFidele = (fidele) => {
    if (selectedFideles.includes(fidele)) {
      setSelectedFideles(selectedFideles.filter((item) => item !== fidele));
    } else {
      setSelectedFideles([...selectedFideles, fidele]);
    }
  };


  const handleSubmitEventToFidels = () => {
    if (selectedFideles.length > 0) {
      if (eventSelect && eventSelect?.value) {
        selectedFideles.map((item) => {
          if (item?._id) {
            SendEventMessageToFidele(eventSelect?.value, item?._id)
          } else {
            toast.error("Message non envoyer car indentifiant absent")
          }
        })
      } else {
        toast.error("Veillez selectionner l'évenement ")
      }
    } else {
      toast.error("Veillez selectionner les fidéles à qui les événement doivent être envoyer ")
      return;
    }
  }





  return (
    <div className="translatable container mx-auto mt-5">
      <h1 className="translatable text-center mb-4 py-3 bg-blue-700 text-white rounded-2xl text-2xl">Liste des Fidèles  ({fidelelist.length})</h1>

      <Button variant="primary" onClick={handleShowCreateModal} className="translatable mb-3 btn btn-outline-primary bg-green-600">
        Ajouter un Fidèle
      </Button>

      <div className="translatable mb-4">
        <Form>
          <div className="translatable d-flex justify-content-between align-items-center">
            <Form.Group controlId="startDate" className="translatable me-2">
              <Form.Label>Date de début</Form.Label>
              <Form.Control
                type="date"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
              />
            </Form.Group>
            <Form.Group controlId="endDate" className="translatable me-2">
              <Form.Label>Date de fin</Form.Label>
              <Form.Control
                type="date"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
              />
            </Form.Group>
            <Button variant="success" onClick={handleFilter} className="translatable mt-4 btn btn-outline-dark flex align-items-center">
              <MdSearch size={30} /><span> Filtrer </span>
            </Button>

            <Button variant="success" onClick={() => {
              if (selectedFideles.length > 0) {
                handleShowEventModal()
              } else {
                toast.error("Veillez selectionner les fildèles s'il vous plait")
              }
            }
            } className="translatable mt-4 btn btn-outline-dark flex align-items-center">
              <MdSend size={30} /><span> Envoyer {selectedFideles.length > 0 ? `(${selectedFideles.length})` : ""} </span>
            </Button>

            <Button variant="success" onClick={exportPDF} className="translatable mt-4 btn btn-outline-dark">
              Exporter en Pdf
            </Button>

          </div>
        </Form>
      </div>

      <Table striped bordered hover>
        <thead>
          <tr>
            <th><input type="checkbox" style={{ widht: "40px", height: "40px" }} checked={selectAll} onChange={toggleSelectAll} /></th>
            <th>Nom & Prénoms</th>
            <th>Indicatif</th>
            <th>Téléphone</th>
            <th>Email</th>
            <th>Adresse</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {(filteredFideles.length > 0 ? filteredFideles : fidelelist).map((fidele) => (
            <tr key={fidele._id}>
              <td>
                <input
                  type="checkbox" style={{ widht: "40px", height: "40px" }}
                  checked={selectedFideles.includes(fidele)}
                  onChange={() => toggleSelectFidele(fidele)}
                />
              </td>
              <td>{fidele.firstname} {fidele.lastname}</td>
              <td>+ {fidele.codePostal}</td>
              <td>{fidele.telephone}</td>
              <td>{fidele.email}</td>

              <td>{fidele.address}</td>
              <td>
                <Dropdown>
                  <Dropdown.Toggle id="dropdown-basic" className="translatable btn btn-outline-primary bg-green-600">
                    Actions
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item onClick={() => handleShowModal(fidele)}>
                      Modifier
                    </Dropdown.Item>
                    <Dropdown.Item onClick={() => StopFidele(fidele._id)}>
                      Bloquer
                    </Dropdown.Item>
                    <Dropdown.Item onClick={() => AccessFidele(fidele._id)}>
                      Débloquer
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>


      {/* Modal pour afficher ou modifier un fidèle */}
      <Modal show={showEventModal} onHide={handleCloseEventModal} centered>
        <Modal.Header closeButton>
          <Modal.Title className="translatable w-full">

            <div className='w-full space-x-6 flex justify-between '>
              <h3 className="translatable text-1xl">Message évenement</h3>
              <Button variant="primary" className="translatable btn btn-outline-dark bg-dark flex align-items-center"
                onClick={() => { handleSubmitEventToFidels() }}
              >
                <MdSend size={30} /> <span>Envoyer  {selectedFideles.length > 0 ? `(${selectedFideles.length})` : ""}</span>
              </Button>
            </div>

          </Modal.Title>
        </Modal.Header>
        <Modal.Body>

          <Form style={{ minHeight: "300px" }}>
            <Form.Group>
              <Form.Label>Choix de l{"'"}événement</Form.Label>
              <Select
                options={eventOptions}
                value={eventSelect}
                onChange={(options) => seteventSelect(options)}
                isClearable
              />
            </Form.Group>

            {eventSelect ?
              <Card>
                <Card.Header>
                  <h3 className="translatable text-2xl">{eventSelect?.label || ""}</h3>

                </Card.Header>
                <Card.Img src={eventSelect?.image} className="translatable h-[200px]" />
                <Card.Body>
                  <p>{eventSelect?.description || ""}</p>
                </Card.Body>
              </Card>
              :
              <Card>
                <Card.Body>
                  <p>Aucun évenement choisi</p>
                </Card.Body>
              </Card>

            }



          </Form>

        </Modal.Body>
      </Modal>

      {/* Modal pour afficher ou modifier un fidèle */}
      <Modal show={showModal} onHide={handleCloseModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Modifier un Fidèle</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedFidele && (
            <Form>
              <Form.Group>
                <Form.Label>Nom</Form.Label>
                <Form.Control
                  type="text"
                  value={selectedFidele.firstname}
                  onChange={(e) => setSelectedFidele({ ...selectedFidele, firstname: e.target.value })}
                />
              </Form.Group>
              <Form.Group>
                <Form.Label>Prénom</Form.Label>
                <Form.Control
                  type="text"
                  value={selectedFidele.lastname}
                  onChange={(e) => setSelectedFidele({ ...selectedFidele, lastname: e.target.value })}
                />
              </Form.Group>
              <Form.Group>
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="email"
                  value={selectedFidele.email}
                  onChange={(e) => setSelectedFidele({ ...selectedFidele, email: e.target.value })}
                />
              </Form.Group>
              <Form.Group>
                <Form.Label>Téléphone</Form.Label>
                <Form.Control
                  type="text"
                  value={selectedFidele.telephone}
                  onChange={(e) => setSelectedFidele({ ...selectedFidele, telephone: e.target.value })}
                />
              </Form.Group>
              <Form.Group>
                <Form.Label>Adresse</Form.Label>
                <Form.Control
                  type="text"
                  value={selectedFidele.address}
                  onChange={(e) => setSelectedFidele({ ...selectedFidele, address: e.target.value })}
                />
              </Form.Group>

              <Button variant="primary" onClick={handleUpdateFidele} className="translatable mt-3 btn btn-outline-primary bg-green-600">
                Sauvegarder
              </Button>
            </Form>
          )}
        </Modal.Body>
      </Modal>

      {/* Modal pour créer un nouveau fidèle */}
      <Modal show={showCreateModal} onHide={handleCloseCreateModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Créer un Nouveau Fidèle</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group>
              <Form.Label>Nom</Form.Label>
              <Form.Control
                type="text"
                value={newFidele.firstname}
                onChange={(e) => setNewFidele({ ...newFidele, firstname: e.target.value })}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Prénom</Form.Label>
              <Form.Control
                type="text"
                value={newFidele.lastname}
                onChange={(e) => setNewFidele({ ...newFidele, lastname: e.target.value })}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                value={newFidele.email}
                onChange={(e) => setNewFidele({ ...newFidele, email: e.target.value })}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Téléphone</Form.Label>
              <Form.Control
                type="text"
                value={newFidele.telephone}
                onChange={(e) => setNewFidele({ ...newFidele, telephone: e.target.value })}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Adresse</Form.Label>
              <Form.Control
                type="text"
                value={newFidele.address}
                onChange={(e) => setNewFidele({ ...newFidele, address: e.target.value })}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Indicatif téléphone</Form.Label>
              <Form.Select
                onChange={(e) => setNewFidele({ ...newFidele, codePostal: e.target.value })}
              >

              <option value="">Choix </option>

                {
                  countryCodes.map((item) => {
                    return (
                      <option value={item?.code}>+{item?.code}  {item?.name} </option>
                    )
                  })
                }
              </Form.Select>

            </Form.Group>
            <Button variant="primary" onClick={handleCreateFidele} className="translatable mt-3 btn btn-outline-primary bg-green-600">
              Ajouter
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ListFidelesPage;